(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fluffsy-econt-checkout-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__fluffsyEcontCheckoutTracking || window.Shopify?.designMode) return;
  window.__fluffsyEcontCheckoutTracking = true;

  const eventName = 'fluffsy:econt_checkout_started';
  const storageKey = 'fluffsy:econt-checkout:v1';
  const cooldown = 30 * 60 * 1000;
  const watched = new WeakSet();
  let lastAttempt = null;
  let busy = false;

  try {
    lastAttempt = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
  } catch {}

  const pause = (milliseconds) =>
    new Promise((resolve) => setTimeout(resolve, milliseconds));

  async function publish(data) {
    const deadline = Date.now() + 5000;

    while (Date.now() < deadline) {
      const analytics = window.Shopify?.analytics;

      if (typeof analytics?.publish === 'function') {
        try {
          const accepted = await analytics.publish(eventName, data);
          if (accepted !== false) return true;
        } catch {}
      }

      await pause(250);
    }

    return false;
  }

  async function recordCheckout() {
    if (busy) return;
    busy = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: AbortSignal.timeout(5000),
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (
        !Array.isArray(cart.items) ||
        !Number.isInteger(cart.item_count) ||
        cart.item_count < 1
      ) return;

      if (
        !Number.isFinite(cart.total_price) ||
        cart.total_price < 0 ||
        cart.currency !== 'EUR'
      ) return;

      const tokenDigest = await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(String(cart.token || ''))
      );

      const cartId = Array.from(
        new Uint8Array(tokenDigest),
        (byte) => byte.toString(16).padStart(2, '0')
      ).join('');

      const fingerprint = JSON.stringify([
        cartId,
        cart.currency,
        cart.total_price,
        cart.items.map((item) => [
          item.key || item.variant_id || item.id,
          item.quantity,
          item.final_line_price,
        ]).sort(),
      ]);

      const now = Date.now();

      if (
        lastAttempt?.fingerprint === fingerprint &&
        now - lastAttempt.timestamp < cooldown
      ) return;

      const data = {
        source: 'econt_popup',
        value: cart.total_price / 100,
        currency: cart.currency,
        num_items: cart.item_count,
        attempt_id: crypto.randomUUID(),
      };

      if (!(await publish(data))) return;

      lastAttempt = { fingerprint, timestamp: now };

      try {
        sessionStorage.setItem(storageKey, JSON.stringify(lastAttempt));
      } catch {}
    } catch {} finally {
      busy = false;
    }
  }

  function watch(element) {
    if (watched.has(element) || !element.shadowRoot) return;

    watched.add(element);

    const root = element.shadowRoot;
    let wasVisible = false;

    function inspect() {
      const overlay = root.querySelector('.popup-overlay');
      const form = root.querySelector('.shipping-form');

      const visible = Boolean(
        overlay?.classList.contains('active') &&
        form &&
        !form.classList.contains('hidden')
      );

      if (visible && !wasVisible) void recordCheckout();
      wasVisible = visible;
    }

    new MutationObserver(inspect).observe(root, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    inspect();
  }

  function scan(node) {
    if (node.nodeType !== 1 && node.nodeType !== 9) return;

    if (node.matches?.('econt-shipping-form')) watch(node);
    node.querySelectorAll?.('econt-shipping-form').forEach(watch);
  }

  function start() {
    scan(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) scan(node);
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
    });

    customElements.whenDefined('econt-shipping-form')
      .then(() => scan(document));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
